export type ThemeType = 'system' | 'light' | 'dark';

export const THEME_COOKIE_NAME = 'haewao-theme';
export const THEME_HEADER_NAME = 'x-haewao-theme';
